export default "__VITE_ASSET__$qYZ7S1e7TjKHvypkiJ9lw__"